import { render, staticRenderFns } from "./DeleteRoomOptionModal.vue?vue&type=template&id=945dc1a8&"
import script from "./DeleteRoomOptionModal.vue?vue&type=script&lang=js&"
export * from "./DeleteRoomOptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports